import { CHAT } from '@/translations/locales/en/chat'
import { COMMON } from '@/translations/locales/en/common'
import { FEATURE_FLAG_DEV_PANEL } from '@/translations/locales/en/components/featureFlagDevPanel'
import { TABLE } from '@/translations/locales/en/components/table'
import { VIEWER } from '@/translations/locales/en/components/viewer'
import { FILE_UPLOADER } from '@/translations/locales/en/fileUploader'

export const en = {
  translation: {
    ...COMMON,
    ...CHAT,
    ...TABLE,
    ...VIEWER,
    ...FEATURE_FLAG_DEV_PANEL,
    ...FILE_UPLOADER,
  },
}
